import Styles from './answer-styles.scss';
import { onSurveyAnswerState } from '@/presentation/pages/survey-result/components';
import React from 'react';
import { useRecoilValue } from 'recoil';
const Answer = ({ answer }) => {
    const { onAnswer } = useRecoilValue(onSurveyAnswerState);
    const activeClassName = answer.isCurrentAccountAnswer ? Styles.active : '';
    const answerClick = (event) => {
        if (event.currentTarget.classList.contains(Styles.active)) {
            return;
        }
        onAnswer(answer.answer);
    };
    return (React.createElement("li", { "data-testid": "answer-wrap", className: [Styles.answerWrap, activeClassName].join(' '), onClick: answerClick },
        answer.image && React.createElement("img", { "data-testid": "image", src: answer.image, alt: answer.answer }),
        React.createElement("span", { "data-testid": "answer", className: Styles.answer }, answer.answer),
        React.createElement("span", { "data-testid": "percent", className: Styles.percent },
            answer.percent,
            "%")));
};
export default Answer;
